module.exports = __webpack_public_path__ + "img/customer-icon-24.bb351053.png";